"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_loadable_1 = require("react-loadable");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var routers_1 = __importStar(require("../router/routers"));
var redux_tools_1 = require("./redux-tools");
function default_1(id, clientOpt) {
    var routers = clientOpt.routers, routerUpdate = clientOpt.routerUpdate, routerLeave = clientOpt.routerLeave, appWrapper = clientOpt.appWrapper, callback = clientOpt.callback, container = clientOpt.container;
    routers_1.configRouters(routers);
    react_loadable_1.preloadReady().then(function () {
        var App = function () {
            return (React.createElement(react_redux_1.Provider, { store: redux_tools_1.store },
                React.createElement(react_router_dom_1.BrowserRouter, null,
                    React.createElement(routers_1.default, { routerUpdate: routerUpdate, routerLeave: routerLeave }))));
        };
        if (appWrapper) {
            App = appWrapper(App);
        }
        react_dom_1.default.hydrate(React.createElement(App, null), container ? container.querySelector("#" + id) : document.getElementById(id));
    });
    if (typeof callback === 'function') {
        callback();
    }
}
exports.default = default_1;
//# sourceMappingURL=SSRReduxEntry.js.map